import React, { useEffect } from "react"
import { size, map, range } from "lodash"
import ClassNames from "classnames"

import { APIResponse } from "redux/apis/types"

// scrollUpElementは実際のDOM要素をセットすることでcurrent変更時にセットした要素までupします
type Props = {
  list: [] | Array<APIResponse.Res>
  current: number
  page: number
  changePage: Function
  total?: number
  scrollUpElement?: HTMLElement
}

export const Pagination: React.FC<Props> = props => {
  const total = !!props.total ? props.total : size(props.list)
  const pageNum =
    Math.floor(total / props.page) + (total % props.page !== 0 ? 1 : 0)
  const toPageNum = props.page * (props.current + 1)
  useEffect(() => {
    if (props.scrollUpElement) {
      props.scrollUpElement.scrollIntoView({
        block: "start",
        behavior: "smooth",
      })
    }
  }, [props.current])
  return size(props.list) ? (
    <div className="pagination-control">
      <div className="pagination-info">
        全{total ? total : "-"}件中
        {props.page * props.current + 1}～
        {toPageNum > total ? total : toPageNum}
        件表示
      </div>
      <ul className="pagination">
        <li
          className={ClassNames("page-nav page-first", {
            disabled: !props.current,
          })}
          onClick={() => props.changePage(0)}
        >
          <div className="btn btn-icon icon-ripple">
            <i className="material-icons">first_page</i>
          </div>
        </li>
        <li
          className="page-nav page-prev"
          onClick={() => !!props.current && props.changePage(props.current - 1)}
        >
          <div className="btn btn-icon icon-ripple">
            <i className="material-icons">chevron_left</i>
          </div>
        </li>
        {map(range(pageNum), (row, key) => {
          const displayPageList =
            props.current < 2
              ? [0, 4]
              : props.current > pageNum - 3
              ? [pageNum - 5, pageNum]
              : [props.current - 2, props.current + 2]
          return displayPageList[0] <= key && key <= displayPageList[1] ? (
            <li
              key={key}
              className={ClassNames({ active: key === props.current })}
              onClick={() => props.changePage(key)}
            >
              <div
                className={ClassNames(
                  "btn btn-outline btn-circle icon-ripple",
                  { active: key === props.current }
                )}
              >
                {key + 1}
              </div>
            </li>
          ) : null
        })}
        <li
          className={ClassNames("page-nav page-next", {
            disabled: pageNum === props.current + 1,
          })}
          onClick={() =>
            pageNum !== props.current + 1 && props.changePage(props.current + 1)
          }
        >
          <div className="btn btn-icon icon-ripple">
            <i className="material-icons">chevron_right</i>
          </div>
        </li>
        <li
          className="page-nav page-last"
          onClick={() => props.changePage(pageNum - 1)}
        >
          <div className="btn btn-icon icon-ripple">
            <i className="material-icons">last_page</i>
          </div>
        </li>
      </ul>
    </div>
  ) : (
    <div className="pagination-info">表示内容がありません</div>
  )
}
